import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { Component } from 'react';
// @ts-ignore
import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n/functions';
/**
 * Creates the styles for the component.
 *
 * @param {Object} theme - The current UI theme.
 *
 * @returns {Object}
 */
const styles = (theme) => {
    return {
        list: {
            listStyleType: 'none',
            padding: 0,
            '& .shortcuts-list__item': {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: theme.spacing(2)
            },
            '& .item-action': {
                backgroundColor: theme.palette.ui04,
                fontWeight: 'bold',
                padding: '1px 4px',
                borderRadius: '4px'
            }
        }
    };
};
/**
 * Implements a React {@link Component} which displays a dialog describing
 * registered keyboard shortcuts.
 *
 * @augments Component
 */
class KeyboardShortcutsDialog extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const shortcuts = Array.from(this.props.shortcutDescriptions)
            .map(description => this._renderShortcutsListItem(...description));
        return (React.createElement(Dialog, { cancelKey: 'dialog.close', submitDisabled: true, titleKey: 'keyboardShortcuts.keyboardShortcuts', width: 'small' },
            React.createElement("div", { id: 'keyboard-shortcuts' },
                React.createElement("ul", { className: clsx('shortcuts-list', this.props.classes.list), id: 'keyboard-shortcuts-list' }, shortcuts))));
    }
    /**
     * Creates a {@code ReactElement} for describing a single keyboard shortcut.
     *
     * @param {string} keyboardKey - The keyboard key that triggers an action.
     * @param {string} translationKey - A description of what the action does.
     * @private
     * @returns {ReactElement}
     */
    _renderShortcutsListItem(keyboardKey, translationKey) {
        var _a;
        let modifierKey = 'Alt';
        if ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.platform) {
            if (window.navigator.platform.indexOf('Mac') !== -1) {
                modifierKey = '⌥';
            }
        }
        return (React.createElement("li", { className: 'shortcuts-list__item', key: keyboardKey },
            React.createElement("span", { "aria-label": this.props.t(translationKey), className: 'shortcuts-list__description' }, this.props.t(translationKey)),
            React.createElement("span", { className: 'item-action' }, keyboardKey.startsWith(':')
                ? `${modifierKey} + ${keyboardKey.slice(1)}`
                : keyboardKey)));
    }
}
export default translate(withStyles(styles)(KeyboardShortcutsDialog));
